const LOAD_DATA_REPORT_JOB_OVERVIEW           = 'LOAD_DATA_REPORT_JOB_OVERVIEW'
const LOAD_DATA_REPORT_JOB_OVERVIEW_SUCCESS   = 'LOAD_DATA_REPORT_JOB_OVERVIEW_SUCCESS'
const LOAD_DATA_REPORT_JOB_OVERVIEW_FAILED    = 'LOAD_DATA_REPORT_JOB_OVERVIEW_FAILED'
const UNMOUNT_DATA_REPORT_JOB_OVERVIEW        = 'UNMOUNT_DATA_REPORT_JOB_OVERVIEW'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const reportJobOverview = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_REPORT_JOB_OVERVIEW:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_REPORT_JOB_OVERVIEW_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_REPORT_JOB_OVERVIEW_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_REPORT_JOB_OVERVIEW:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default reportJobOverview;